import React, { useEffect, useRef } from "react";

/**
 * Image picker with optional URL fallback. Uploads via parent onSubmit using uploadImage().
 */
export default function ImageUploadField({
  label = "Image",
  imageUrl = "",
  previewUrl = "",
  pendingFile = null,
  onImageUrlChange,
  onFileSelect,
  onClearFile,
  uploading = false,
  folderHint = "JPEG, PNG, WebP or GIF",
  allowUrl = true,
  className = "span-2",
}) {
  const fileInputRef = useRef(null);
  const showPreview = previewUrl || imageUrl;

  useEffect(() => () => {
    // Parent owns object URL lifecycle when using pendingFile
  }, []);

  return (
    <div className={`field-label image-upload-field ${className}`.trim()}>
      <span>{label}</span>
      <div
        className={`image-upload-zone${showPreview ? " has-image" : ""}`}
        role="button"
        tabIndex={0}
        onClick={() => fileInputRef.current?.click()}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") fileInputRef.current?.click();
        }}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept="image/jpeg,image/png,image/webp,image/gif"
          hidden
          onChange={onFileSelect}
        />
        {showPreview ? (
          <img src={previewUrl || imageUrl} alt="Preview" className="image-upload-preview" />
        ) : (
          <div className="image-upload-placeholder">
            <strong>Click to upload</strong>
            <span>{folderHint}</span>
          </div>
        )}
      </div>
      {pendingFile && (
        <p className="field-hint">
          New image selected — uploads when you save.
          {" "}
          <button type="button" className="link-btn" onClick={onClearFile}>Clear</button>
        </p>
      )}
      {allowUrl && (
        <label className="field-label" style={{ marginTop: 8 }}>
          Or paste image URL
          <input
            value={imageUrl}
            onChange={(e) => onImageUrlChange(e.target.value)}
            placeholder="https://..."
            disabled={uploading}
          />
        </label>
      )}
    </div>
  );
}
